module.exports = __webpack_public_path__ + "static/media/engie_logo_gris.2e216c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/engie_logo_gris.png
// module id = 1759
// module chunks = 0